import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { rSetFetchJobBatchList, rSetShowFab } from "../../redux/reducers/GlobalVariables";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";

import configServ from "../../services/config";
import CreateJobBatchCard from "./CreateJobBatchCard";
import CreateJobBatchTable from "./CreateJobBatchTable";
import Swal from "sweetalert2";

const CreateJobBatchPage = () => {
  //#region code
  const { company_id, user_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables,
  );
  const open = useSelector((state) => state.sideExpand.open);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [jobCategoryList, setJobCategoryList] = useState([]);
  const [editData, setEditData] = useState({});
  const [jobBatchList, setJobBatchList] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    //     fetchSalesOrderList();
    scrollToTop();
  }, []);

  const handlePopup = () => {
    if (isCreate === true) {
      clear();
    }
    dispatch(rSetShowFab(isCreate));
    setIsCreate(!isCreate);
    setIsEdit(false);
  };

  const handleEdit = (data) => {
    dispatch(rSetShowFab(isCreate));
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
    // console.log("object", data);
  };

  const clear = () => {
    setEditData({});
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const fetchJobBatchList = async () => {
    try {
      setLoader(true);

      const res = await configServ.getJobBatches({
        company_id: company_id,
        user_id: user_id,
        is_admin: Boolean(is_super || is_admin),
        page: page + 1,
        per_page: rowsPerPage,
      });

      if (res.status) {
        setJobBatchList(res.data);
        setTotal(res.pagination.total);
      } else {
        setJobBatchList([]);
        setTotal(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  // 🔥 IMPORTANT: dependency add karo
  useEffect(() => {
    fetchJobBatchList();
  }, [page, rowsPerPage, isChanged]);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await configServ.deleteJobBatch(id);
      if (response.status) {
        Swal.fire({
          title: "Deleted!",
          text: "Record has been deleted.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setIsChanged((p) => !p);
        dispatch(rSetFetchJobBatchList(true)); // Dispatch the action to update the state
      }
    } catch (e) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong",
        icon: "error",
      });
      console.log(e);
    }
  };

  //#endregion

  return (
    <>
      <Container>
        <CardHeadMenu
          prefix={"Na"}
          suffix={"Na"}
          title={"JOB BATCH"}
          handlePopup={handlePopup}
          isEdit={isEdit}
          create={isCreate}
          showCreate={Boolean(
            is_super || is_admin || permissions?.includes(82),
          )}
        />

        {isCreate && (
          <CreateJobBatchCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            clear={clear}
            setIsChanged={setIsChanged}
            isChanged={isChanged}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            setEditData={setEditData}
          />
        )}
        <CreateJobBatchTable
          handleEdit={handleEdit}
          isChanged={isChanged}
          jobBatchList={jobBatchList}
          loader={loader}
          page={page}
          rowsPerPage={rowsPerPage}
          total={total}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          handleDelete={handleDelete}
        />
      </Container>
    </>
  );
};
export default CreateJobBatchPage;
